import { render, staticRenderFns } from "./efficientAndRespond.vue?vue&type=template&id=2e67f96e&scoped=true&"
import script from "./efficientAndRespond.vue?vue&type=script&lang=js&"
export * from "./efficientAndRespond.vue?vue&type=script&lang=js&"
import style0 from "./efficientAndRespond.vue?vue&type=style&index=0&id=2e67f96e&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e67f96e",
  null
  
)

export default component.exports